module.exports = __webpack_public_path__ + "images/mobile/coupons/xwz-cover-1e239de74a89248c6b03a7957c7c794c.png";